import styled from "styled-components";

export const Title = styled.h2`
  color: ${({ theme }) => theme.textLight};
  font-family: ${({ theme }) => theme.fontHeavy};
  font-size: 26px;
  text-align: center;
  margin: 0 0 24px 0;

  .accent {
    color: ${({ theme }) => theme.primary};
  }
`;

export const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 28px 0;
`;

export const Bullet = styled.li`
  color: ${({ theme }) => theme.grey2};
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 12px;
  padding-left: 18px;
  position: relative;

  &::before {
    content: "•";
    color: ${({ theme }) => theme.highlight};
    position: absolute;
    left: 0;
  }
`;

export const EditorPromo = styled.div`
  background-color: ${({ theme }) => theme.backgroundDark};
  border-radius: 6px;
  padding: 20px 24px;
  margin-bottom: 28px;

  .title {
    color: ${({ theme }) => theme.textLight};
    font-family: ${({ theme }) => theme.fontHeavy};
    font-size: 15px;
    margin-bottom: 8px;
  }

  .new {
    margin-left: 8px;
    font-family: ${({ theme }) => theme.fontMedium};
    color: ${({ theme }) => theme.highlight};
    font-size: 13px;
  }

  p {
    color: ${({ theme }) => theme.grey2};
    font-size: 13px;
    line-height: 1.5;
    margin: 0 0 16px 0;
  }
`;

/**
 * EditorStemsEmblem uses floats internally; wrapping it with overflow:hidden
 * acts as a clearfix so the floated stem boxes stay inside the EditorPromo
 * card and don't bleed into the actions row below.
 */
export const StemsWrap = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 8px;

  .link {
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.grey2};
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 14px;
    padding: 8px 4px;
  }

  .link:hover {
    color: ${({ theme }) => theme.textLight};
  }
`;
